module.exports = "promotions-0.0.1-87e1d6cdeb1746aa361326fbef56f74e33993678";